import { AppointmentsData } from '@/types/general';

export const data: AppointmentsData['appointments'] = [];
